module.exports = __webpack_public_path__ + "img/impression-opacity30.dd848480.png";